 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import KRAE_9781440501029_EPUB_COV from '@/components/Krae_9781440501029_epub_cov'
 import SS_US_ADULT_SIGNUP_FRONT from '@/components/SS_US_adult_signup_front'
 import LOVE_1 from '@/components/love_1'
 import KRAE_9781440501029_EPUB_TP from '@/components/Krae_9781440501029_epub_tp'
 import KRAE_9781440501029_EPUB_PART1 from '@/components/Krae_9781440501029_epub_part1'
 import KRAE_9781440501029_EPUB_DED from '@/components/Krae_9781440501029_epub_ded'
 import KRAE_9781440501029_EPUB_PART3 from '@/components/Krae_9781440501029_epub_part3'
 import KRAE_9781440501029_EPUB_TOC from '@/components/Krae_9781440501029_epub_toc'
 import KRAE_9781440501029_EPUB_INT from '@/components/Krae_9781440501029_epub_int'
 import KRAE_9781440501029_EPUB_P1 from '@/components/Krae_9781440501029_epub_p1'
 import KRAE_9781440501029_EPUB_C1 from '@/components/Krae_9781440501029_epub_c1'
 import KRAE_9781440501029_EPUB_C2 from '@/components/Krae_9781440501029_epub_c2'
 import KRAE_9781440501029_EPUB_P2 from '@/components/Krae_9781440501029_epub_p2'
 import KRAE_9781440501029_EPUB_C3 from '@/components/Krae_9781440501029_epub_c3'
 import KRAE_9781440501029_EPUB_C4 from '@/components/Krae_9781440501029_epub_c4'
 import KRAE_9781440501029_EPUB_C5 from '@/components/Krae_9781440501029_epub_c5'
 import KRAE_9781440501029_EPUB_P3 from '@/components/Krae_9781440501029_epub_p3'
 import KRAE_9781440501029_EPUB_C6 from '@/components/Krae_9781440501029_epub_c6'
 import KRAE_9781440501029_EPUB_C7 from '@/components/Krae_9781440501029_epub_c7'
 import KRAE_9781440501029_EPUB_C8 from '@/components/Krae_9781440501029_epub_c8'
 import KRAE_9781440501029_EPUB_P4 from '@/components/Krae_9781440501029_epub_p4'
 import KRAE_9781440501029_EPUB_C9 from '@/components/Krae_9781440501029_epub_c9'
 import KRAE_9781440501029_EPUB_C10 from '@/components/Krae_9781440501029_epub_c10'
 import KRAE_9781440501029_EPUB_C11 from '@/components/Krae_9781440501029_epub_c11'
 import KRAE_9781440501029_EPUB_P5 from '@/components/Krae_9781440501029_epub_p5'
 import KRAE_9781440501029_EPUB_C12 from '@/components/Krae_9781440501029_epub_c12'
 import KRAE_9781440501029_EPUB_C13 from '@/components/Krae_9781440501029_epub_c13'
 import KRAE_9781440501029_EPUB_C14 from '@/components/Krae_9781440501029_epub_c14'
 import KRAE_9781440501029_EPUB_C15 from '@/components/Krae_9781440501029_epub_c15'
 import KRAE_9781440501029_EPUB_C16 from '@/components/Krae_9781440501029_epub_c16'
 import KRAE_9781440501029_EPUB_C17 from '@/components/Krae_9781440501029_epub_c17'
 import KRAE_9781440501029_EPUB_C19 from '@/components/Krae_9781440501029_epub_c19'
 import LOVE_2 from '@/components/love_2'
 import SS_US_ADULT_SIGNUP_BACK from '@/components/SS_US_adult_signup_back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_cov",
 			"name" : "Krae_9781440501029_epub_cov",
 			"component" : KRAE_9781440501029_EPUB_COV
 		},
 		{
 			"path" : "/SS_US_adult_signup_front",
 			"name" : "SS_US_adult_signup_front",
 			"component" : SS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_tp",
 			"name" : "Krae_9781440501029_epub_tp",
 			"component" : KRAE_9781440501029_EPUB_TP
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_part1",
 			"name" : "Krae_9781440501029_epub_part1",
 			"component" : KRAE_9781440501029_EPUB_PART1
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_ded",
 			"name" : "Krae_9781440501029_epub_ded",
 			"component" : KRAE_9781440501029_EPUB_DED
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_part3",
 			"name" : "Krae_9781440501029_epub_part3",
 			"component" : KRAE_9781440501029_EPUB_PART3
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_toc",
 			"name" : "Krae_9781440501029_epub_toc",
 			"component" : KRAE_9781440501029_EPUB_TOC
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_int",
 			"name" : "Krae_9781440501029_epub_int",
 			"component" : KRAE_9781440501029_EPUB_INT
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_p1",
 			"name" : "Krae_9781440501029_epub_p1",
 			"component" : KRAE_9781440501029_EPUB_P1
 		},
 		{
 			"path" : "/Krae_9781440501029_epub_c1",
 			"name" : "Krae_9781440501029_epub_c1",
 			"component" : KRAE_9781440501029_EPUB_C1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js